export { Avatar } from './Avatar';
export type { Props } from './Avatar.types';
